function getScreenTranslation(screen: string, i18next: any) {
  return i18next.i18n.store.data[i18next.i18n.language][screen];
}

export { getScreenTranslation };
